<template>
    <b-container fluid class="align-self-center">
        <!--        <b-row class="logintop w-100 justify-content-center p-4 flex-center m-0">-->
        <!--            <b-col cols="4" class="logo flex-center">-->
        <!--                <b-img :src="require('../../assets/img/logo.png')" fluid alt="eTicket" />-->
        <!--            </b-col>-->
        <!--            <b-col cols="4" class="w-100">-->
        <!--                <h3>Register</h3>-->
        <!--            </b-col>-->
        <!--            <b-col cols="4">-->
        <!--            </b-col>-->
        <!--        </b-row>-->
        <b-row class="justify-content-center align-items-center p-4 m-4 main-register">
            <b-col cols="12" md="4">
                <b-form v-on:submit.prevent="register" class="auth-form"  data-vv-scope="registerForm">
                    <b-form-group label-for="email">{{$t('profil.email')}}
                        <b-form-input :state="validateState('registerForm.email')"
                                      :class="{'is-invalid': veeErrors.has('registerForm.email')}"
                                      v-model="user.email" v-validate="'required|email'" id="email" type="email" size="md" name="email" required></b-form-input>
                        <span class="vvError">{{ veeErrors.first('registerForm.email') }}</span>
                    </b-form-group>

                    <b-form-group label-for="username">{{$t('profil.user')}}
                        <b-form-input :state="validateState('registerForm.username')"
                                      :class="{'is-invalid': veeErrors.has('registerForm.username')}"
                                      v-model="user.username" v-validate="'required|min:4'" id="username" type="text" size="md" name="username" required></b-form-input>
                        <span class="vvError">{{ veeErrors.first('registerForm.username') }}</span>
                    </b-form-group>

                    <b-form-group label-for="password">{{$t('profil.pass')}}
                        <b-form-input :state="validateState('registerForm.password')"
                                      :class="{'is-invalid': veeErrors.has('registerForm.password')}"
                                      v-model="user.password" v-validate="'required|alpha_num'" id="password" type="password" size="md" name="password" required></b-form-input>
                        <span class="vvError">{{ veeErrors.first('registerForm.password') }}</span>
                    </b-form-group>

                    <b-form-group label-for="role">{{$t('profil.role')}}
                        <b-form-select v-model="user.role_id" name="role" v-validate="'required'">
                            <option v-for="role in roles" :value="role.id">{{role.name}}</option>
                        </b-form-select>
                        <span class="vvError">{{ veeErrors.first('registerForm.role') }}</span>
                    </b-form-group>
                    <!--                    <div class="form-help d-flex justify-content-between">-->
                    <!--                        <router-link to="login">-->
                    <!--                            Login-->
                    <!--                        </router-link>-->
                    <!--                        <b-link>-->
                    <!--                            Help-->
                    <!--                        </b-link>-->
                    <!--                    </div>-->

                    <b-btn type="submit" variant="primary" class="mt-3 w-25">
                        {{$t('profil.register')}}
                    </b-btn>
                </b-form>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        data() {
            return {
                user:{},
                roles: [],
                printError: ('toast.printError'),
            }
        },
        name: 'register',
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            register: function() {
                this.$validator.validateAll('registerForm').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('register',
                            this.user
                        ).then(response => {
                            if(response.data.success) {
                                this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                                this.$router.push('/');
                            }else{
                                this.$toasted.global.err({
                                    message : this.$t(response.data.data.msg)
                                });
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                }).catch(err => {
                    //vratit gresku
                });
            },
            getRoles(){
                this.$axios.get('roles').then(response => {
                    if (response.status === 200) {
                        this.roles = response.data.data;
                    }
                })
            },
        },
        created() {
            this.getRoles();
        }
    }
</script>

<style lang="scss">
    .logintop{
        background-image: url('../../assets/img/login.jpg');
        background-size: cover;
        color: #FFF;
        height: 10vh;
    }

    .logo{
        img {
            height: 5vh;
        }
    }

    .main-register{
        height: 80vh;
    }
</style>